import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user-check",
  "use": "user-check-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"user-check\"><path d=\"M12.168 13.25a5.75 5.75 0 115.75-5.75 5.76 5.76 0 01-5.75 5.75zm0-10a4.25 4.25 0 104.25 4.25 4.26 4.26 0 00-4.25-4.25z\" /><path d=\"M3.168 21.25a.76.76 0 01-.75-.75 8.77 8.77 0 018.75-8.75h2a.75.75 0 010 1.5h-2a7.26 7.26 0 00-7.25 7.25.76.76 0 01-.75.75zM15.169 22.25a.75.75 0 01-.5-.25l-4-4a.75.75 0 011-1l3.43 3.43 6.51-7.43a.75.75 0 111.12 1l-7 8a.73.73 0 01-.53.26l-.03-.01z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol